module.exports = __webpack_public_path__ + "right.2n2sMc9z.svg";